export default "__VITE_ASSET__JL$EFhfZ__";